import * as React from "react";
import * as $ from "jquery";

interface IUploaderProps {
    rename?: string;
    extensions: Array<string>;
    sizes: any;
	resizeCallback?:Function;
	crop?:any; //inkább a sizeknél a modify-t haszsnálja
	max_files:number;
	display_uplodader?:boolean;
}

interface IUploaderState {
    errors: Array<string>;
    success: Array<string>;
}

export class Uploader extends React.Component<IUploaderProps, IUploaderState>{
    protected upload_process_current: number = 0;
    protected upload_process_max: number;
    protected upload_process_data: any;
	protected resize_results:any;
	protected resize_index:number;
	protected current_image_blob:string;
	protected canvas:HTMLCanvasElement;

    //disabled
    protected server_process: boolean = false;
    //from porps
    protected current_file_name: string;
	/*
	[
		{
			width: 640,
			height: 480
		},
		{
			width: 480,
			height: 0
		},
		{
			width: 0,
			height: 480
		},
		{ //thumbnail
			width: 100,
			height: 100
		},
		{
			width: 1024,
			height: 768
		},
	]
	*/
    protected sizes: any;
    protected extensions: Array<string>;

    constructor(props: IUploaderProps) {
        super(props);
        // set initial state
        this.state = {
            errors: [],
            success: [],
        };
    }

    componentDidMount() {
        this.setState({
            errors: [],
            success: []
        });
    }

    fileChangeHandler(evt) {
        evt.preventDefault();
		var err: Array<string> = [];
		if ( evt.target.files.length < 1 ) {
			err.push('Kérjük, töltsön fel egy fájlt!');

		}
		for (var key in evt.target.files) {
		    var item = evt.target.files[key];
			if ( item.size !== undefined ) {
				var file_name:Array<string> = item.name.split('.');
				var ext:string = file_name[file_name.length - 1];
				ext = ext.toLowerCase();
				if (  this.props.extensions.indexOf(ext) === -1 ) {
		            err.push('Hibás formátumú fájl:'+item.name + ' Engedélyezett formátumok: '+  this.props.extensions.join(','));
		        }
	        }
		}
		this.setState({
			errors: err
		} as IUploaderState);
		if ( err.length > 0 ) {
			return;
		}
		this.canvas = $(evt.target).parents('.uploader_box').find(".canvas")[0] as HTMLCanvasElement;
        this.upload_process_current = 0;
        this.upload_process_max = evt.target.files.length;
        this.upload_process_data = evt.target.files;
		this.setState({
			success: ['Feltöltés...']
		} as IUploaderState);
        this.uploadFile();
    }

    private uploadFile(): void {
        var file: any = this.upload_process_data[this.upload_process_current];
        if (file === undefined) {
            console.log(this.upload_process_current);
        }

        var file_name: Array<string> = file.name.split('.');
        delete file_name[file_name.length - 1]; //kit törlés

        if (this.props.rename !== undefined && this.props.rename !== '') {
            file_name[file_name.length - 2] = this.props.rename;
        }
        this.current_file_name = file_name.join('_');
        if (file) {
            this.readFile(file);
        }
    }

    protected readFile(imgFile: File): void {
        if (this.props.sizes !== false && !imgFile.type.match(/image.*/)) {
            console.log("The dropped file is not an image: ", imgFile.type);
            return;
        }

        var reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
            this.renderImage(e.target.result, imgFile);
        };
        reader.readAsDataURL(imgFile);
    }

    protected renderImage(src: string, imgFile: File) {
        if (this.props.sizes === false || this.server_process === true) {
            // sima fájl
            if (imgFile.name.indexOf('.php') === -1 && imgFile.name.indexOf('.js') === -1 && imgFile.name.indexOf('.py') === -1) {
                // első csekkolás, mielőtt a szervert terhelnénk
				this.resize_results = [];
                this.resize_results.push({
                    file_name: imgFile.name.replace(/(_[0-9]+x[0-9]+)/, ''),
                    //file: /*src*/ 'from FILES array!'
                    file: src
                });
                this.resize_index = this.resize_results.length;
                this.completed();
            }
        } else {
            this.createSourceImage(src);
        }
    }

	protected  createSourceImage(src:any) {
	  this.current_image_blob = src;
	  this.resize(src, null, null, () => { this.startResize(); }, true);
	}

    protected startResize(): void {
        // if (this.current_image_blob.indexOf('/png') > -1) {
        //     this.current_image_blob = this.canvas.toDataURL("image/png");
        // } else {
            this.current_image_blob = this.canvas.toDataURL("image/jpeg");
        // }
        this.resize_results = [];
        this.resize_index = this.resize_results.length;
		this.setState({
			success: ['Resizing... ' + this.resize_results.length + '/' + this.props.sizes.length]
		} as IUploaderState);
        this.looping();
    }

    protected looping(): void {
        var modify = 'box';
        var current_size = this.props.sizes[this.resize_index];
        if (current_size.modify !== undefined) {
			//crop miatt van ilyen lehetőségünk
            modify = current_size.modify;
        }
        this.resize(this.current_image_blob, current_size.width, current_size.height,
			() => {
				var resized_image_blob:string = '';
	            var rext:string = '';
				// if (this.current_image_blob.indexOf('/jpeg') > -1) {
				// 	resized_image_blob = this.canvas.toDataURL("image/jpeg");
		        //     rext = 'jpg';
				// }else if (this.current_image_blob.indexOf('/png') > -1) {
	            //     resized_image_blob = this.canvas.toDataURL("image/png");
	            //     rext = 'png';
	            // }else{
					//default force:
					resized_image_blob = this.canvas.toDataURL("image/jpeg");
		            rext = 'jpg';
				// }
	            this.resize_results.push({
	                file_name: (this.current_file_name.replace(/(_[0-9]+x[0-9]+)/, '') + '_' + current_size.width + 'x' + current_size.height + '.' + rext).replace('__', '_'),
	                file: resized_image_blob
	            });
	            if (this.resize_results.length !== this.props.sizes.length) {
	                this.resize_index = this.resize_results.length;
					this.setState({
		                success: ['Resizing... ' + this.resize_results.length + '/' + this.props.sizes.length]
		            } as IUploaderState);
	                this.looping();
	            } else {
	                this.completed();
	            }
	        },
            undefined,
            modify);
    }

    protected resize(src: string, w: number, h: number, fg?: Function, first?: any, modify?: string) {
        var img = new Image();
        img.onload = () => {
            if ( this.canvas === undefined) {
                return;
            }
            var x = 0;
            var y = 0;
            var canvas_width:number = img.width;
            var canvas_height:number = img.height;
            //crop center
            if (w !== null && h !== null) {
                if ( this.props.crop !== undefined ) {
                    if (w === h) { //négyzetes kép esetén, ez egy speckó
                        if (this.props.crop.align === 'center') {

                            if (img.height < img.width) {
                                if (img.height > h) {
                                    img.width *= h / img.height;
                                    img.height = h;
                                }
                            } else {
                                if (img.width > w) {
                                    img.height *= w / img.width;
                                    img.width = w;
                                }
                            }
                            x = (w - img.width) / 2;
                            y = (h - img.height) / 2;

                            canvas_width = w;
                            canvas_height = h;
                        }else if (this.props.crop.align === 'top') {

                            if (img.height < img.width) {
                                if (img.height > h) {
                                    img.width *= h / img.height;
                                    img.height = h;
                                }
                            } else {
                                if (img.width > w) {
                                    img.height *= w / img.width;
                                    img.width = w;
                                }
                            }
                            x = (w - img.width) / 2;
                            y = 0;

                            canvas_width = w;
                            canvas_height = h;
                        }
                    }
                } else {
                    // box
                    if (modify === undefined || modify === 'box') {
                        //sima meretezes start
                        if (h > 0 && img.height > h) {
                            img.width *= h / img.height;
                            img.height = h;
                        }
                        if (w > 0 && img.width > w) {
                            img.height *= w / img.width;
                            img.width = w;
                        }
                        canvas_width = img.width;
                        canvas_height = img.height;
                        //sima meretezes end
                    } else if (modify === 'crop') {
						if (img.height < img.width) {
							if (img.height > h) {
								img.width *= h / img.height;
								img.height = h;
							}
						} else {
							if (img.width > w) {
								img.height *= w / img.width;
								img.width = w;
							}
						}
						x = (w - img.width) / 2;
						y = 0;

						canvas_width = w;
						canvas_height = h;
                    } else if (modify === 'crop_top_height') {

						if (img.width > w) {
							var new_height = img.height *= w / img.width;
							if (new_height >= h) {
								img.height = new_height;
								img.width = w;
							}
						}

						x = (w - img.width) / 2;
						y = 0;

						canvas_width = w;
						canvas_height = h;
                    }
                }
            } else {
                //original size
                canvas_width = img.width;
                canvas_height = img.height;
            }

            var ctx = this.canvas.getContext("2d");
            //ctx.ImageSmoothingEnabled = false;
            ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

            this.canvas.width = canvas_width;
            this.canvas.height = canvas_height;
			ctx.drawImage(img, x, y, img.width, img.height);
            //watermark place
            // if (watermark_img !== null) {
            //     if (first !== undefined && first === true) {
            //         var wx = img.width - watermark_img.width;
            //         var wy = img.height - watermark_img.height;
            //         ctx.drawImage(watermark_img, wx, wy, watermark_img.width, watermark_img.height);
            //     }
            // }
            if (fg !== undefined) {
                fg();
            }
        };
        img.src = src;
    }

    protected completed(): void {
        if (this.upload_process_current < (this.upload_process_max - 1) /*ha van több feltölti*/) {
            this.setState({
                success: ['Feltöltés... (' + (this.current_file_name + 1) + '/' + this.upload_process_max + ')']
            } as IUploaderState);
            ++this.upload_process_current;
            this.uploadFile();
        } else {
            this.setState({
                success: []
            } as IUploaderState);
        }
		if ( this.props.resizeCallback !== undefined ) {
			this.props.resizeCallback(this.resize_results);
		}
    }

    render() {
        var errors = this.state.errors;
        var success = this.state.success;
		var upload_attr:boolean = false;
		if ( this.props.max_files > 1 ) {
		    // upload_attr = 'multiple="multiple"';
		    upload_attr = true;
		}
		var uploader_style:any = { display: 'none' };
		if ( this.props.display_uplodader !== undefined && this.props.display_uplodader === true ) {
			uploader_style = { display: 'block' };
		}
        return (
            <div className="uploader_box">
                <div className="alert alert-danger">
                    {errors.map((item: any, index:number) => {
                        return <div key={index}>{item}</div>;
                    })}
                </div>
                <div className="alert alert-info">
                    {success.map((item: any, index:number) => {
                        return <div key={index}>{item}</div>;
                    })}
                </div>
                <input type="file" className="file_uploader_btn" style={ uploader_style }  multiple={ upload_attr } onChange={e => this.fileChangeHandler(e)} />
                <div className="preview" style={{ display: 'none' }}>
                    <canvas className="canvas" />
                </div>
            </div>
        );
    }
}
/*
<Uploader extensions={this.state.extensions} sizes={this.state.sizes} rename="logo" max_files="1" resizeCallback={ items => this.submitHandler(items) } />

ReactDOM.render(<Uploader extensions={[ 'jpg', 'jpeg', 'png' ]} sizes={[
	{
		width: 640,
		height: 480,
		modify: crop
	},
	{
		width: 1024,
		height: 768
	},
]} />, document.getElementById('logo_uploader_component'));
*/



// WEBPACK FOOTER //
// ./lib/components/Uploader.tsx